/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingAccountCCCreateDTO } from '../models/BillingAccountCCCreateDTO';
import type { BillingAccountCCTokenPayFrameAttribCreateDTO } from '../models/BillingAccountCCTokenPayFrameAttribCreateDTO';
import type { BillingAccountInstaPayDetails } from '../models/BillingAccountInstaPayDetails';
import type { CCPaymentCreatePayFrameAttribsResponseDTO } from '../models/CCPaymentCreatePayFrameAttribsResponseDTO';
import type { CCTokenUrlFormDetailsDTO } from '../models/CCTokenUrlFormDetailsDTO';
import type { InstaPayACHPayment } from '../models/InstaPayACHPayment';
import type { InstaPayCCPayment } from '../models/InstaPayCCPayment';
import type { InstaPayCCToken } from '../models/InstaPayCCToken';
import type { PaymentTransactionDetails } from '../models/PaymentTransactionDetails';
import type { PaymentTypeEnum } from '../models/PaymentTypeEnum';
import { request as __request } from '../core/request';

export class InstaPayVService {

    /**
     * @param billingAccountId
     * @returns string OK
     * @throws ApiError
     */
    public static async instaPayVGetQrCode(
        billingAccountId?: string,
    ): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/instapay/qrcode`,
            query: {
                'billingAccountId': billingAccountId,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @returns BillingAccountInstaPayDetails OK
     * @throws ApiError
     */
    public static async instaPayVGetBillingAccountInfo(
        billingAccountId?: string,
    ): Promise<BillingAccountInstaPayDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/instapay/account`,
            query: {
                'billingAccountId': billingAccountId,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @returns CCTokenUrlFormDetailsDTO OK
     * @throws ApiError
     */
    public static async instaPayVGetCcUrl(
        billingAccountId?: string,
    ): Promise<CCTokenUrlFormDetailsDTO> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/instapay/cc-url`,
            query: {
                'billingAccountId': billingAccountId,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns CCPaymentCreatePayFrameAttribsResponseDTO OK
     * @throws ApiError
     */
    public static async instaPayVGetCCiFrame(
        billingAccountId?: string,
        requestBody?: BillingAccountCCTokenPayFrameAttribCreateDTO,
    ): Promise<CCPaymentCreatePayFrameAttribsResponseDTO> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/instapay/cc-iframe`,
            query: {
                'billingAccountId': billingAccountId,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns InstaPayCCToken OK
     * @throws ApiError
     */
    public static async instaPayVCreateCc(
        billingAccountId?: string,
        requestBody?: BillingAccountCCCreateDTO,
    ): Promise<InstaPayCCToken> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/instapay/createcc`,
            query: {
                'billingAccountId': billingAccountId,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PaymentTransactionDetails Created
     * @throws ApiError
     */
    public static async instaPayVPayWithCc(
        requestBody?: InstaPayCCPayment,
    ): Promise<PaymentTransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/instapay/cc`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PaymentTransactionDetails Created
     * @throws ApiError
     */
    public static async instaPayVPayWithAch(
        requestBody?: InstaPayACHPayment,
    ): Promise<PaymentTransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/instapay/ach`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param paymentType
     * @param amount
     * @param pendingId
     * @returns number Created
     * @throws ApiError
     */
    public static async instaPayVGetServiceFee(
        billingAccountId: string,
        paymentType: PaymentTypeEnum,
        amount: number,
        pendingId?: string,
    ): Promise<number> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/instapay/service-fee`,
            query: {
                'BillingAccountId': billingAccountId,
                'PaymentType': paymentType,
                'Amount': amount,
                'PendingId': pendingId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

}